import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback } from 'react';
import { useTrack } from '../track';
import { useBaseAnalyticsProperties } from '../useBaseAnalyticsProperties';
import { VIEWED_AGE_CONFIRMATION_ERROR } from './eventNames';
export var useTrackViewedAgeConfirmationError = function useTrackViewedAgeConfirmationError() {
  var _useBaseAnalyticsProp = useBaseAnalyticsProperties(),
      _useBaseAnalyticsProp2 = _slicedToArray(_useBaseAnalyticsProp, 1),
      base = _useBaseAnalyticsProp2[0];

  var track = useTrack(VIEWED_AGE_CONFIRMATION_ERROR);
  return useCallback(function (error) {
    track(_objectSpread(_objectSpread({}, base), {}, {
      error: error
    }));
  }, [base, track]);
};